/* eslint-disable unicorn/filename-case */
/* eslint-disable arrow-body-style */
import { UWBlockingPoint } from '@xengage/gw-portals-edge-validation-js';

const BLOCKS_QUOTES = [UWBlockingPoint.BLOCKS_QUOTE, UWBlockingPoint.BLOCKS_QUOTE_RELEASE];

function isQuoteBlocked(underwritingIssues) {
    return underwritingIssues ? underwritingIssues.some((uwIssue) => uwIssue.currentBlockingPoint !== UWBlockingPoint.NON_BLOCKING):false;
}


function findBlockingPoint(underwritingIssues) {
    return underwritingIssues ? underwritingIssues.some((issue) => { return BLOCKS_QUOTES.includes(issue.currentBlockingPoint);}): false; 
}


function UWIssuesNonBlocking(underwritingIssues) {
    return underwritingIssues ? underwritingIssues.filter((uwIssue) =>
        uwIssue.currentBlockingPoint !== UWBlockingPoint.NON_BLOCKING
        && uwIssue.currentBlockingPoint !== UWBlockingPoint.BLOCKS_BIND
        && uwIssue.currentBlockingPoint !== UWBlockingPoint.BLOCKS_ISSUANCE
    ) : [];
}

export default {
    isQuoteBlocked,
    findBlockingPoint,
    UWIssuesNonBlocking
};